module.exports = __webpack_public_path__ + "static/media/quotesHeader.66effb47.png";